import { MapLike } from '../core'
import { metadata } from '../Network/MetaTypes'

export type ReportedWithMetaData = { meta: metadata; decodedPayload?: string }

export type StateType<ReportedType extends MapLike<any> = MapLike<any>, CalculatedType extends MapLike<any> = MapLike<any>> = {
  reported: ReportedType & { meta?: metadata; decodedPayload?: string }
  calculated?: CalculatedType
}

export type PayloadMessageType = {
  state: StateType
  timestamp?: number
  thingId?: string
  thingSk?: string
}

export type TypedPayloadMessageType<ReportedType extends MapLike<any> = MapLike<any>, CalculatedType extends MapLike<any> = MapLike<any>> = {
  state: StateType<ReportedType, CalculatedType>
  timestamp?: number
  thingId?: string
  thingSk?: string
}

/**
 * full check for validity not expected to work with anything pre 2022
 * @param x
 * @returns
 */
export const isPayloadMessageType = (x: MapLike<any> | undefined): x is PayloadMessageType => {
  return isPayloadMessageStateReportedMetdataType(x?.state ?? {})
}

const isPayloadMessageStateReportedMetdataType = (x: MapLike<any> | undefined): x is ReportedWithMetaData => {
  return isMetadata((x as { reported: ReportedWithMetaData })?.reported?.meta)
}

const isMetadata = (x: MapLike<any> | undefined): x is metadata => {
  return (x as metadata)?.timestamp !== undefined && (x as metadata)?.deviceId !== undefined
}

// export type { PayloadMessageType };
